import { render } from "./Result.vue?vue&type=template&id=69fdfb52&scoped=true&ts=true&lang=pug"
import script from "./Result.vue?vue&type=script&lang=ts&setup=true"
export * from "./Result.vue?vue&type=script&lang=ts&setup=true"

import "./Result.vue?vue&type=style&index=0&id=69fdfb52&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69fdfb52"]])

export default __exports__